import "./CompanyPanel.css";

import { ReactNode } from "react";

import { Divider, FlyoutPanel } from "../../../../../widget";

interface CompanyPanelLayoutProps {
  show: boolean;
  onClose: () => void;
  header: string;
  title: string;
  subtitle?: string;
  headerAction?: ReactNode;
  sectionTitle: string;
  sectionAction?: ReactNode;
  showTitleBlock?: boolean;
  showSectionHeader?: boolean;
  children: ReactNode;
}

export const CompanyPanelLayout = ({
  show,
  onClose,
  header,
  title,
  subtitle,
  headerAction,
  sectionTitle,
  sectionAction,
  showTitleBlock = true,
  showSectionHeader = true,
  children,
}: CompanyPanelLayoutProps): JSX.Element => {
  return (
    <FlyoutPanel
      show={show}
      onClose={onClose}
      size="Large"
      header={header}
      buttonsChildren={headerAction ?? null}
      contentChildren={
        <div className="CompanyPanel">
          {showTitleBlock && (
            <div className="CompanyPanelTitleBlock">
              <h2>{title}</h2>
              {subtitle && <p className="CompanyPanelSubtitle">{subtitle}</p>}
            </div>
          )}
          {showTitleBlock && <Divider type="horizontal" className="CompanyPanelDivider" />}
          {showSectionHeader && (
            <div className="CompanyPanelSectionHeader">
              <h2>{sectionTitle}</h2>
              {sectionAction}
            </div>
          )}
          <div className="CompanyPanelSectionContent">{children}</div>
        </div>
      }
    />
  );
};
